var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 123,
    viewBox: "0 0 132 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_4836)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M35.5626 57.5634C24.5469 63.3239 16.4575 73.2113 16.0073 83.8591C15.5571 94.493 23.6465 105.408 36.0691 108.817C39.2626 109.69 48.5338 114.028 56.4966 110.042C61.4347 107.577 61.2518 104.338 70.8325 95.3662C75.447 91.0422 77.7402 88.8873 80.8072 87.493C89.5578 83.5211 94.9039 87.5915 98.5476 83.9014C102.754 79.6479 99.7716 70.0422 97.5488 65.507C92.2168 54.6056 80.779 51.507 79.2596 51.1549C75.1797 50.1972 70.7481 50.493 66.5557 50.5352C61.4629 50.5915 56.356 51.0986 51.4038 52.0986C45.8186 53.2253 40.4163 55.0282 35.5626 57.5634Z",
    fill: "#18499A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9727 45.9155L58.016 47.3099L56.989 46.6056L55.4133 45.5211C54.1612 44.662 52.7122 44.1972 51.1928 44.1549L44.5665 43.9859L38.8687 40.0141L37.49 39.0563L31.145 34.6338C30.934 34.4789 30.6526 34.4084 30.3994 34.4648C30.1321 34.507 29.8929 34.662 29.7522 34.8873L12.2087 60.6197C12.054 60.8451 11.9977 61.1127 12.054 61.3803C12.1102 61.6479 12.2791 61.8873 12.5042 62.0282L19.0742 66.1408L20.5092 67.0423L26.221 70.6197C27.1355 71.1831 27.9374 71.9155 28.6127 72.7746L31.5671 76.5352L32.3549 77.5352L31.0325 78.5915L30.7511 78.2394L27.2762 73.8169C26.7416 73.1127 26.0803 72.5211 25.3347 72.0563L11.6178 63.4648C10.9848 63.0704 10.5627 62.4507 10.4079 61.7324C10.2532 61.0141 10.4079 60.2676 10.8159 59.662L28.3595 33.9296C28.7534 33.338 29.3724 32.9296 30.0899 32.8028C30.8074 32.6761 31.5249 32.831 32.1158 33.2394L45.1151 42.3099L51.235 42.4648C53.078 42.507 54.8506 43.0845 56.37 44.1268L58.4944 45.5775L58.9727 45.9155Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9624 82.0141C92.6529 82.0563 92.3434 82.0845 92.0198 82.0845C91.3445 82.0845 90.6693 81.9718 89.994 81.7746H89.9236C89.8392 81.7183 89.7548 81.6901 89.6985 81.662L89.6563 81.6479C89.0795 81.4789 88.4183 81.1408 87.7852 80.7042L71.4938 69.9437L72.4223 68.5211L88.7419 79.2958C89.2483 79.662 89.7689 79.9155 90.2894 80.0845V80.0986L90.3738 80.1268H90.3879L90.402 80.1408C90.9647 80.3803 92.0339 80.9718 92.9624 82.0141Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4852 92.3944C90.5004 92.9578 89.4031 93.2394 88.2917 93.2394C87.4194 93.2394 86.5472 93.0704 85.7171 92.7324C85.1544 92.507 84.6198 92.2113 84.1133 91.831L82.7908 90.9155L65.6412 78.9296L66.612 77.5352L83.9585 89.6761L85.084 90.4648C86.8004 91.7183 88.9669 91.9014 90.6411 90.9296C92.878 89.6338 93.3704 86.831 92.6951 84.8451C92.0902 83.0704 90.627 82.1268 89.9236 81.7747C89.8392 81.7183 89.7548 81.6901 89.6985 81.662L90.3879 80.1268L90.4019 80.1408C90.9647 80.3803 92.0339 80.9718 92.9624 82.0141C93.497 82.6056 93.9754 83.3662 94.2989 84.3099C95.1853 86.9296 94.4959 90.6479 91.4852 92.3944Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4707 99.7605C78.0357 99.7605 76.5585 99.3239 75.2501 98.4507L60.3234 88.0141L61.2941 86.6338L76.2068 97.0704C77.9794 98.2394 80.1179 98.4225 81.778 97.5211C82.4251 97.169 83.9727 96.1408 84.1415 94.2958C84.3244 92.4648 83.0582 91.169 82.805 90.9296L83.9586 89.6901C84.3103 90.0282 86.0829 91.831 85.8156 94.4507C85.5483 97.1127 83.4662 98.5211 82.5658 99C81.6232 99.507 80.554 99.7605 79.4707 99.7605Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5922 106.296C69.7211 106.296 67.9203 105.366 66.9074 104.831C65.8241 104.268 65.0504 103.676 64.4876 103.239C63.6435 102.577 62.8275 101.859 62.0959 101.07L63.334 99.9155C64.0093 100.634 64.7408 101.31 65.5146 101.901C66.0492 102.324 66.7245 102.831 67.6812 103.338C68.9333 103.986 71.2546 105.197 73.0132 104.282C73.1117 104.239 73.1679 104.197 73.2383 104.155C74.9968 103.056 75.3767 101.014 75.3767 101C75.6018 99.7183 75.2079 98.6479 74.9406 98.1268L76.46 97.3803C76.8117 98.0845 77.3463 99.5352 77.0368 101.296C77.0227 101.408 76.5303 104.099 74.1246 105.592C74.0261 105.648 73.9276 105.718 73.7869 105.789C73.0835 106.155 72.3379 106.296 71.5922 106.296Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1676 85.3662C35.8862 85.3662 35.6189 85.3521 35.3375 85.3098C33.8462 85.0986 32.5379 84.3098 31.6515 83.1126C30.7652 81.9155 30.3854 80.4366 30.6105 78.9436C30.8215 77.4507 31.6093 76.1408 32.8052 75.2535L35.3375 73.3662C36.5333 72.4788 38.0105 72.0986 39.5018 72.3239C40.9931 72.5352 42.3015 73.3239 43.1878 74.5211C45.0308 77 44.5243 80.5211 42.0342 82.3803L39.5018 84.2676C38.517 84.9859 37.3634 85.3662 36.1676 85.3662ZM38.6577 73.9577C37.8136 73.9577 37.0117 74.2253 36.3364 74.7324L33.804 76.6197C32.974 77.2394 32.4253 78.1549 32.2706 79.1972C32.1158 80.2394 32.3831 81.2676 33.0021 82.1126C33.6211 82.9436 34.5356 83.4929 35.5767 83.6479C36.6178 83.8028 37.6448 83.5352 38.4889 82.9155L41.0212 81.0281C42.7517 79.7324 43.1174 77.2676 41.8231 75.5352C41.2041 74.7042 40.2897 74.1549 39.2486 74C39.0375 73.9718 38.8547 73.9577 38.6577 73.9577Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4456 94.8028C37.7292 94.8028 36.041 94.0282 34.9437 92.5493C34.0573 91.3521 33.6775 89.8732 33.9026 88.3803C34.1277 86.8873 34.9014 85.5775 36.0973 84.6901L45.0308 78.0282C47.5069 76.1831 51.024 76.6901 52.8811 79.1831C54.7241 81.662 54.2176 85.1831 51.7275 87.0423L42.7939 93.7042C41.781 94.4366 40.6133 94.8028 39.4456 94.8028ZM48.3651 78.6056C47.5491 78.6056 46.7331 78.8592 46.0297 79.3803L37.0961 86.0423C36.2661 86.662 35.7174 87.5775 35.5627 88.6197C35.4079 89.662 35.6752 90.6901 36.2942 91.5352C37.5885 93.2676 40.0506 93.6338 41.781 92.338L50.7145 85.6761C52.445 84.3803 52.8108 81.9155 51.5164 80.1831C50.7427 79.1549 49.5609 78.6056 48.3651 78.6056Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7882 100.507C47.5069 100.507 47.2396 100.493 46.9582 100.451C45.4669 100.239 44.1585 99.4507 43.2722 98.2535C41.4292 95.7746 41.9357 92.2535 44.4258 90.3943L50.5457 85.831C53.0217 83.9859 56.553 84.4929 58.3959 86.9859C59.2823 88.1831 59.6621 89.6619 59.437 91.1549C59.226 92.6479 58.4381 93.9577 57.2423 94.845L51.1225 99.4084C50.1517 100.127 48.9841 100.507 47.7882 100.507ZM53.894 86.4084C53.078 86.4084 52.262 86.6619 51.5586 87.1831L45.4388 91.7465C43.7083 93.0422 43.3426 95.507 44.6369 97.2394C45.2559 98.0704 46.1703 98.6197 47.2114 98.7746C48.2525 98.9296 49.2795 98.6619 50.1236 98.0422L56.2434 93.4788C57.0735 92.8591 57.6222 91.9436 57.7769 90.9014C57.9317 89.8591 57.6644 88.831 57.0454 87.9859C56.2716 86.9577 55.0898 86.4084 53.894 86.4084Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7228 105.789C54.105 105.789 52.5011 105.056 51.4601 103.648C49.7156 101.296 50.208 97.9718 52.5433 96.2253L55.8635 93.7465C58.213 92 61.5332 92.4929 63.2777 94.831C64.1218 95.9577 64.4735 97.3662 64.2625 98.7605C64.0514 100.169 63.3199 101.408 62.1944 102.254L58.8742 104.732C57.9316 105.451 56.8202 105.789 55.7228 105.789ZM59.029 94.3943C58.2833 94.3943 57.5236 94.6338 56.8765 95.1127L53.5563 97.5915C51.9525 98.7887 51.6289 101.056 52.8106 102.648C54.0065 104.239 56.2715 104.577 57.8613 103.394L61.1815 100.915C61.9552 100.338 62.4476 99.4929 62.5883 98.5352C62.729 97.5774 62.4898 96.6197 61.913 95.8591C61.2237 94.8873 60.1404 94.3943 59.029 94.3943Z",
    fill: "#18499A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1944 102.254C63.3199 101.408 64.0514 100.169 64.2625 98.7605C64.4735 97.3662 64.1218 95.9577 63.2777 94.831C61.5332 92.4929 58.213 92 55.8635 93.7465L52.5433 96.2253C50.208 97.9718 49.7156 101.296 51.4601 103.648C52.5011 105.056 54.105 105.789 55.7228 105.789C56.8202 105.789 57.9316 105.451 58.8742 104.732L62.1944 102.254ZM62.1944 102.254L61.6879 101.577M59.029 94.3943C58.2833 94.3943 57.5236 94.6338 56.8765 95.1127L53.5563 97.5915C51.9525 98.7887 51.6289 101.056 52.8106 102.648C54.0065 104.239 56.2715 104.577 57.8613 103.394L61.1815 100.915C61.9552 100.338 62.4476 99.4929 62.5883 98.5352C62.729 97.5774 62.4898 96.6197 61.913 95.8591C61.2237 94.8873 60.1404 94.3943 59.029 94.3943Z",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9611 38.3764L18.6213 66.8219L20.017 67.7729L39.3567 39.3275L37.9611 38.3764Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4944 45.5775L58.9727 45.9155L58.016 47.3098L56.989 46.6056L58.4944 45.5775Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7862 35.1549L87.2646 35.845L85.8858 36.831L85.3934 36.1267L86.7862 35.1549Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.311 66.6338L106.918 67.5775L106.44 66.8732L107.833 65.9296L108.311 66.6338Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.311 66.6338L106.919 67.5775L106.44 66.8732L90.2754 43.2394L91.6682 42.2817L107.833 65.9296L108.311 66.6338Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3457 40.2394L88.9529 41.2112L85.886 36.831L85.3936 36.1267L86.7863 35.1549L87.2647 35.845L90.3457 40.2394Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3346 10.3521H73.6464V16.2817H75.3346V10.3521Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3346 21.8451H73.6464V27.7747H75.3346V21.8451Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1848 18.2112H77.262V19.9014H83.1848V18.2112Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7049 18.2112H65.782V19.9014H71.7049V18.2112Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8469 94.6479H19.1587V100.775H20.8469V94.6479Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8469 106.521H19.1587V112.648H20.8469V106.521Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9926 102.803H22.8728V104.493H28.9926V102.803Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1328 102.803H11.0129V104.493H17.1328V102.803Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.346 83.5916H113.657V88.4648H115.346V83.5916Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.346 93.0422H113.657V97.9155H115.346V93.0422Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.662 89.9014H116.795V91.5916H121.662V89.9014Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.222 89.9014H107.355V91.5916H112.222V89.9014Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.654 61.0986C116.513 61.8169 116.105 62.4226 115.5 62.831L99.6872 73.4226L98.7446 72.0282L106.44 66.8733L106.918 67.5775L108.311 66.6338L107.833 65.9296L114.558 61.4226C114.783 61.2817 114.938 61.0423 114.994 60.7888C115.036 60.5211 114.98 60.2535 114.839 60.0282L95.2837 31.3662C95.129 31.1409 94.8898 30.9859 94.6225 30.9437C94.3552 30.9014 94.0879 30.9578 93.8769 31.1127L87.2646 35.8451L86.7863 35.155L85.3935 36.1268L85.8859 36.831L76.4881 43.5493L69.5523 42.0986C68.1313 41.8028 66.6401 42.0986 65.4442 42.9014L45.5794 56.3944C44.1163 57.169 43.23 58.5352 43.2018 60.0423C43.1596 61.8169 44.3554 63.4507 46.0859 64C47.549 64.4789 49.2372 64.0423 50.3768 62.9014L50.5175 62.7888C56.0042 59.2535 61.491 55.7324 66.9777 52.2113L67.1043 52.1268C67.2591 52.0423 67.4138 51.9437 67.5545 51.8592C67.7234 51.9437 67.8781 52.0423 68.0469 52.1409L94.0316 69.9719C96.7609 71.6902 98.2381 74.5775 97.7316 77.2958C97.591 78.0423 97.0845 79.8873 95.34 81.0845C94.6225 81.5634 93.8206 81.8873 92.9624 82.0141C92.0339 80.9719 90.9647 80.3803 90.4019 80.1409C91.8369 80.5916 93.3 80.4366 94.3833 79.6902C95.6073 78.8451 95.9731 77.5211 96.0716 77C96.4373 74.9859 95.2415 72.7324 93.1031 71.3803L67.5545 53.8592C62.2085 57.2817 56.8624 60.7183 51.5023 64.169C49.9266 65.7042 47.6053 66.2676 45.5653 65.6197C43.1315 64.8451 41.4573 62.5352 41.5136 60C41.5558 57.8873 42.7938 55.9437 44.7212 54.9437L56.989 46.6057L58.016 47.3099L58.9727 45.9155L58.4944 45.5775L64.4876 41.5071C66.0633 40.4366 68.0329 40.0423 69.8899 40.4366L76.1082 41.7324L92.8921 29.7465C93.4829 29.324 94.2004 29.1549 94.9179 29.2817C95.6354 29.4085 96.2685 29.8169 96.6765 30.4085L116.232 59.0704C116.64 59.6761 116.781 60.3944 116.654 61.0986Z",
    fill: "#18499A",
    stroke: "#18499A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_4836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 103,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB3);
export default __webpack_public_path__ + "static/media/b3.8f59474e64106f6cafd2542e44015c9e.svg";
export { ForwardRef as ReactComponent };